import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getTopicSelectionResult: host + 'reportResult/getTopicSelectionResult',//选题统计
};

export const getTopicSelectionResult = (body, callBack) => {  //选题统计
    request({url:Apis.getTopicSelectionResult, body, callBack});
};